import type { FC } from "react";

import { withLabelColon } from "../Form/formFieldLabelPositioning/withLabelColon";
import { FieldLabelStyle, RequiredMark } from "./drawerFormStyles";

type FieldLabelProps = {
    label: string;
    isRequiredField?: boolean;
};

/**
 * Batch update drawer field label, adds the label colon and the optional required mark
 * */
export const FieldLabel: FC<FieldLabelProps> = ({ label, isRequiredField }) => (
    <FieldLabelStyle>
        {withLabelColon(label)}
        {isRequiredField && <RequiredMark> †</RequiredMark>}
    </FieldLabelStyle>
);
